import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Industries from "./pages/Industries";
import Journey from "./pages/Journey";
import Estimator from "./pages/Estimator";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import AdminLeads from "./pages/AdminLeads";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ChargeHub from "./pages/ChargeHub";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/solutions" element={<Navigate to="/products" replace />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/journey" element={<Journey />} />
                  <Route path="/estimator" element={<Estimator />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/chargehub" element={<ChargeHub />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/guard/:moduleSlug" element={<ProductDetail />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
